import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-6 text-right" }
const _hoisted_2 = { class: "text-lg font-semibold mb-2" }
const _hoisted_3 = { class: "mt-6 text-right" }
const _hoisted_4 = { class: "text-lg font-semibold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("skills")), 1),
      _createVNode(_TransitionGroup, {
        name: "skill-fade",
        tag: "div",
        class: "flex flex-wrap gap-2 justify-end"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
            return (_openBlock(), _createElementBlock("span", {
              key: skill.id,
              class: _normalizeClass([
          'px-4 py-2 rounded-lg text-sm transition-all duration-500 shadow-sm backdrop-blur-sm',
          _ctx.highlightedSkillIds.includes(skill.id)
            ? 'shadow-md text-gray-900'
            : 'bg-gray-100/80 text-gray-900',
        ]),
              style: _normalizeStyle(
          _ctx.highlightedSkillIds.includes(skill.id)
            ? 'background: linear-gradient(90deg, #A4C9A2 0%, #C2F5D4 100%);'
            : ''
        )
            }, _toDisplayString(skill.name), 7))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("learningSkills")), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "px-4 py-2 rounded-lg text-sm shadow-sm backdrop-blur-sm bg-gray-100/80 text-gray-900 justify-end" }, " React ", -1))
    ])
  ], 64))
}